// extracted by mini-css-extract-plugin
export var cardLayout = "_7f-1";
export var paginationContainer = "_7f-0";